import React from 'react'
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

const CtClasification = ({
    isTcp,
    than3mmLegend,
    ICONS_BY_LABEL,
    doughnutDataThan,
    doughnutoptions
}) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="title-components">{t('extended_report.classification_according_to_CT')}</h3>

            <div>
                <p className='ct-pmr'>{t('extended_report.project_distribution_TCDI')}</p>
            </div>


            {(isTcp) ? (
                <div className='clasification-distribution'>
                    <div className='content-projects'>
                        <div>
                            {than3mmLegend.map(({ label, value, color }) => {
                                const Icon = ICONS_BY_LABEL[label];
                                return (
                                    <div key={label}>
                                        <div className='content-distribution legend-circle'>
                                            <div className='legend-circle'>
                                                {Icon && <Icon className='legend-svg' />}
                                            </div>
                                            <p>{label}</p>
                                        </div>
                                        <p className='numberOfProyects'>{`${value} ${t('one_pager_report.projects')}`}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className='doughnut-monitoring'>
                        <Doughnut data={doughnutDataThan} options={doughnutoptions} />
                    </div>

                </div>
            ) : (
                <div className='na-content'>
                    <p>N/A</p>
                </div>
            )}
        </>
    )
}

export default CtClasification